import {AfterViewInit, Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {ReCaptcha2Component} from 'ngx-captcha';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
})
export class CaptchaComponent implements AfterViewInit {
  // export class CaptchaComponent , AfterViewInit {
  recaptchaSiteKey = environment.recaptchaSiteKey;

  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  @Output() tokenChange = new EventEmitter<string | null>();
  private captchaObserver: MutationObserver;
  onSuccess(token: string): void {
    this.tokenChange.emit(token);
  }

  onExpired(): void {
    this.tokenChange.emit(null);
  }

  reset(): void {
    this.captchaElem.resetCaptcha();
  }

  // Quando abrir o desafio de imagens
  onCaptchaLoad(): void {}

  ngAfterViewInit(): void {}
}
